import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeWrapperComponent } from './component/home-wrapper/home-wrapper.component';
import { LanguageComponent } from './component/language/language.component';
import { HowToBuyComponent } from './component/how-to-buy/how-to-buy.component';
import { PartnerComponent } from './component/partner/partner.component';
import { AirdropComponent } from './component/airdrop/airdrop.component';
import { TermsComponent } from './component/terms/terms.component';
import { PrivacyComponent } from './component/privacy/privacy.component';
import { CookiesComponent } from './component/cookies/cookies.component';
import { FournotpageComponent } from './component/fournotpage/fournotpage.component';
import { LangGuardGuard } from './lang-guard.guard';


const routes: Routes = [
  { path: 'terms-and-conditions', redirectTo: 'en/terms-and-conditions', component: TermsComponent, title: 'Terms & Conditions | Best Wallet', },
  { path: 'privacy-policy', redirectTo: 'en/privacy-policy', component: PrivacyComponent, title: 'Privacy Policy | Best Wallet' },
  { path: 'cookies', redirectTo: 'en/cookies', component: CookiesComponent, },
  { path: 'partner', component: PartnerComponent, title: 'Partners - Get featured in Best Wallet | Best Wallet' },
  { path: 'partner/:lang', component: PartnerComponent, title: 'Partners - Get featured in Best Wallet | Best Wallet' },
  { path: 'airdrop', component: AirdropComponent },
  { path: 'airdrop/:lang', component: AirdropComponent },


  {
    path: '', component: LanguageComponent, pathMatch: 'full', children: [{
      path: '', pathMatch: 'full', component: HomeWrapperComponent
    }]
  },


  {
    path: ':lang', component: LanguageComponent, canActivate: [LangGuardGuard], children: [
      {
        path: '', component: HomeWrapperComponent, children: [
          { path: 'feature', component: HomeWrapperComponent, },
          { path: 'roadmap', component: HomeWrapperComponent, },
          { path: 'best-token-airdrop', component: HomeWrapperComponent, },
        ],
      },

      { path: 'terms-and-conditions', component: TermsComponent, title: 'Terms & Conditions | Best Wallet', },
      { path: 'privacy-policy', component: PrivacyComponent, title: 'Privacy Policy | Best Wallet' },
      { path: 'cookies', component: CookiesComponent, },
      { path: 'how-to-buy', component: HowToBuyComponent },
    ]
  },

  { path: '404', component: FournotpageComponent },
  { path: '**', component: FournotpageComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
